export { default as Discover } from './Discover';
export { default as Feed } from './Feed';
export { default as Sections } from './Sections';
export { default as Groups } from './Groups';
export { default as Profile } from './Profile';
export { default as Layout } from './Layout';



// WEBPACK FOOTER //
// ./src/tabs/index.js